export function shouldSkipDeviceRedirectByUtmCampaign(utmCampaign) {
  return utmCampaign && utmCampaign.indexOf('nof2019') !== -1;
}

// Header script to init AppsFlyer Banner SDK requested by Replug:
// https://idagio.slack.com/archives/C051LRSPB97/p1687526933366239?thread_ts=1687524918.244809&cid=C051LRSPB97
//
// Original AppsFlyer documentation: https://support.appsflyer.com/hc/en-us/articles/4410472474001#appsflyer-web-sdk-for-smart-banners-only
export const appsFlyerBannerScript = `
  !function(t,e,n,s,a,c,i,o,p){t.AppsFlyerSdkObject=a,t.AF=t.AF||function(){(t.AF.q=t.AF.q||[]).push([Date.now()].concat(Array.prototype.slice.call(arguments)))},t.AF.id=t.AF.id||i,t.AF.plugins={},o=e.createElement(n),p=e.getElementsByTagName(n)[0],o.async=1,o.src="https://websdk.appsflyer.com?"+(c.length>0?"st="+c.split(",").sort().join(",")+"&":"")+(i.length>0?"af_id="+i:""),p.parentNode.insertBefore(o,p)}(window,document,"script",0,"AF","banners",{banners: {key: "${process.env.APPSFLYER_BANNER_KEY}"}});
  AF('banners', 'showBanner')
`;



// WEBPACK FOOTER //
// /tmp/build_83f21ab6/src/appsflyer.js